<template>
    <ColumnaIzquierda></ColumnaIzquierda>
    <SelectInput></SelectInput>
</template>
<script>
import ColumnaIzquierda from '../components/ColumnaIzquierda.vue';
import SelectInput from '../components/SelectInput.vue';
export default {
    name: 'TargetView',
    components: {
        ColumnaIzquierda,
        SelectInput,
    }
}
</script>